module.exports = __webpack_public_path__ + "assets/collective-price.33dd3320.svg";